import {
  SIGNUP_COUPON_FAILURE,
  SIGNUP_FAILURE,
  SIGNUP_MAGICLINK_FAILURE,
  SIGNUP_MAGICLINK_SUCCESS,
  SIGNUP_REQUEST,
  SIGNUP_SUCCESS,
  SIGNUP_VALIDATION_FAILURE,
} from './actionTypes';

// TODO transform booleans into a status string
const initialState = {
  error: false,
  invalidCoupon: false,
  magicLinkSent: false,
  isLoading: true,
  firstname: '',
};

export default function signupReducer(state = initialState, action) {
  switch (action.type) {
    case SIGNUP_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case SIGNUP_SUCCESS:
    case SIGNUP_VALIDATION_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    case SIGNUP_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: true,
      };
    case SIGNUP_MAGICLINK_SUCCESS:
      return {
        ...state,
        isLoading: false,
        magicLinkSent: true,
        firstname: action.firstname,
      };
    case SIGNUP_MAGICLINK_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: true,
      };
    case SIGNUP_COUPON_FAILURE:
      return {
        ...state,
        isLoading: false,
        invalidCoupon: true,
      };
    default:
      return state;
  }
}
